import Vue from 'vue';
import { mapGetters } from 'vuex';
import loadingDroplet from '@editor/droplets/_bubble-options/components/loading-droplet';

export default Vue.component('canvas-editor', {
  template: require('./template.html'),
  components: {
    loadingDroplet,
  },
  computed: {
    ...mapGetters([
      'currentPage',
      'viewport',
      'activeDroplet',
      'revertTriggered',
    ]),
    type() {
      return this.currentPage.type.split('.')[0] || this.currentPage.type;
    },
    getWidth() {
      let width = '100%';
      if (this.viewport === 'mobile') {
        width = '600px';
      }
      if (this.viewport === 'tablet') {
        width = '992px';
      }
      return width;
    },
  },
  name: 'canvas-editor',
  data() {
    const renderKey = Date.now();
    return {
      renderKey,
    };
  },
  watch: {
    revertTriggered(is) {
      // when a droplet is reverted using the history feature,
      // we need to make sure to force a re-render
      if (is) {
        this.renderKey = Date.now();
      }
    },
    'currentPage.bounceDroplet': function watchDroplet(bounce) {
      // bouncing the component key will force a re-render. This is needed
      // to regenerate styles and plugins on cancel edits
      if (bounce) {
        this.renderKey = Date.now();
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/canvas/index.js